import { render, staticRenderFns } from "./TalentModal.vue?vue&type=template&id=bd273dca&scoped=true"
import script from "./TalentModal.vue?vue&type=script&lang=js"
export * from "./TalentModal.vue?vue&type=script&lang=js"
import style0 from "./TalentModal.vue?vue&type=style&index=0&id=bd273dca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd273dca",
  null
  
)

export default component.exports